import { render, staticRenderFns } from "./ClientMetrics.vue?vue&type=template&id=df2e4126"
import script from "./ClientMetrics.vue?vue&type=script&lang=ts"
export * from "./ClientMetrics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports